import { Spinner } from 'react-activity'
import 'react-activity/dist/Spinner.css'

const LoadingIndicator = ({ color, size, style }) => {
  return (
    <Spinner color={color ?? '#d65944'} size={size ?? 24} style={style} />
  )
}

export default LoadingIndicator